import { List, Create, Details } from "../Components/index.js";

export default [
    {
        path: "/letter/seal",
        component: List,
        name: "letter.seal",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/letter/seal/create",
        component: Create,
        name: "letter.seal.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/letter/seal/:id/view",
        component: Details,
        name: "letter.seal.view",
        meta: {
            requiresAuth: true,
        },
    },
];
